// ── CallRegister 목록 영역 스타일 ────────────────────────────────────────────
// 필터 행, 모바일 카드, 페이지 헤더, 섹션 헤더 관련 스타일
// dark mode: CSS 변수 토큰 사용 (index.css .dark{} 에서 자동 전환)
// 결과/킵 chip + 모달 스타일은 listChipStyles.js 참고

/** 필터 행: 킵·검색 필터 영역 — 회색 띠 없이 입력칸·버튼만 (2026-09-15 사용자 요청) */
export const filterRowStyle = {
  display: 'flex',
  gap: 8,
  marginBottom: 12,
  flexWrap: 'wrap',
  alignItems: 'center',
};

/** 킵만 보기 토글 버튼 */
export const filterKeepBtnStyle = (active) => ({
  border: `1px solid ${active ? 'rgba(245,158,11,0.5)' : 'var(--border)'}`,
  borderRadius: 8,
  padding: '6px 12px',
  fontSize: 12,
  fontWeight: 700,
  cursor: 'pointer',
  background: active ? 'rgba(245,158,11,0.12)' : 'var(--bg-card)',  // 반투명 앰버 — dark mode 호환
  color: active ? '#d97706' : 'var(--text-sub)',                     // text-muted는 dark bg에서 안 보임
  whiteSpace: 'nowrap',
  flexShrink: 0,
});

/** 필터 전체검색 텍스트 입력 필드 */
export const filterSearchInputStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '6px 10px',
  flex: 1,
  minWidth: 180,
  fontSize: 12,
  background: 'var(--bg-card)',
  color: 'var(--text)',
};

/** 필터 적용 건수 배지 (stdBadgeActive 색 통일 — 연파랑+파랑, 색 테두리 제거) */
export const filterCountBadgeStyle = {
  fontSize: 11,
  fontWeight: 700,
  color: 'var(--std-badge-text, #1d7de6)',
  background: 'var(--std-badge-bg, rgba(59,154,242,0.12))',   // 반투명 파랑 — dark mode 호환
  border: 'none',
  borderRadius: 999,
  padding: '3px 10px',
  whiteSpace: 'nowrap',
};

/** 모바일 카드 목록 컨테이너 */
export const mobileAdminListStyle = { display: 'grid', gap: 10 };

/** 모바일 개별 콜 카드: 배경 (그림자 없음 — 관리자 표준 디자인 통일, 2026-08-27) */
export const mobileAdminCardStyle = {
  border: '1px solid var(--border)',
  borderRadius: 12,
  padding: '12px 14px',
  background: 'var(--bg-card)',
  boxShadow: 'none',
};

/** 모바일 카드 상단: 상호명 + 콜일자/담당자 구분선 */
export const mobileAdminTopStyle = { marginBottom: 10, borderBottom: '1px solid var(--border)', paddingBottom: 8 };

/** 모바일 카드 상호명 */
export const mobileAdminTitleStyle = { fontSize: 14, fontWeight: 800, color: 'var(--text)' };

/** 모바일 카드 부제목(콜일자, 담당자) */
export const mobileAdminSubStyle = { marginTop: 3, fontSize: 11, color: 'var(--text-muted)', fontWeight: 500 };

/** 모바일 카드 2열 정보 그리드 */
export const mobileAdminGridStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 };

/** 모바일 카드 개별 정보 항목 */
export const mobileAdminItemStyle = { display: 'grid', gap: 2 };

/** 모바일 카드 항목 레이블 */
export const mobileAdminLabelStyle = { fontSize: 10, color: 'var(--text-muted)', fontWeight: 700 };

/** 모바일 카드 항목 값 */
export const mobileAdminValueStyle = { fontSize: 12, color: 'var(--text-sub)', fontWeight: 600, overflowWrap: 'anywhere' };

/** 모바일 카드 내용 값: 조금 더 연한 색상 */
export const mobileAdminContentValueStyle = { ...mobileAdminValueStyle, fontWeight: 500, color: 'var(--text-muted)' };

/** 모바일 카드 액션 버튼 영역: 우측 정렬 */
export const mobileAdminActionsStyle = { marginTop: 10, display: 'flex', justifyContent: 'flex-end', gap: 6 };

// ── 직원 전용 페이지 디자인 요소 ─────────────────────────────────────────────

/** 직원 페이지 상단 헤더: 겉 박스 없음 (2026-09-15 — 관리자 화면과 같은 디자인).
 *  휴대폰 좌우 16px 은 공통 틀(AdminLayout main)이 준다 — 아래 등록 폼·목록과 같이 0 (2026-09-28). */
export const pageHeaderStyle = (isMobile) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  ...(isMobile && { paddingInline: 0 }),
});

/** 페이지 타이틀 */
export const pageTitleStyle = {
  fontSize: 20,
  fontWeight: 900,
  color: 'var(--text)',
  letterSpacing: '-0.3px',
};

/** 페이지 부제목: 오늘 날짜 텍스트 */
export const pageSubtitleStyle = {
  fontSize: 12,
  color: 'var(--text-muted)',
  fontWeight: 500,
  marginTop: 3,
};

/** 오늘 입력 건수 배지: 인디고 배경의 알약형 */
export const todayBadgeStyle = {
  background: 'rgba(99,102,241,0.12)',  // 반투명 인디고 — dark mode 호환
  color: '#6366f1',
  borderRadius: 20,
  padding: '6px 14px',
  fontSize: 13,
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

/** 섹션 헤더 행: 섹션 제목 + 우측 배지/상태 텍스트 — 밑줄 없음 (2026-09-15) */
export const sectionHeaderRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 12,
};

/** 섹션 제목 텍스트 */
export const sectionLabelStyle = {
  fontSize: 13,
  fontWeight: 800,
  color: 'var(--text-sub)',
  letterSpacing: '-0.2px',
};

/** 목록 건수 배지: 알약형 */
export const listCountBadgeStyle = {
  background: 'var(--bg-subtle)',
  color: 'var(--text-sub)',
  borderRadius: 12,
  padding: '3px 10px',
  fontSize: 11,
  fontWeight: 700,
};

/** 직원 전용 모바일 카드: 좌측 인디고 강조선 */
export const mobileEmployeeCardStyle = {
  ...mobileAdminCardStyle,
  borderLeft: '3px solid #6366f1',
  borderRadius: 10,
};

// 결과/킵 chip 스타일, 수정·킵 해제 모달 스타일 → listChipStyles.js 참고
